define(function(require) {
    // GEOCODER_CP layer definition config (utiliser avec SearchToolExtend.js)

    var _createCoordinates = function(coordArray, cartoVistaCoordinates) {
        _.forEach(coordArray, function(coordinates, idx){
             var x = coordinates[0] * 20037508.34 / 180,
                 y = Math.log(Math.tan((90 + coordinates[1]) * Math.PI / 360)) / (Math.PI / 180);
             y = y * 20037508.34 / 180;
             if(idx == 0){
                cartoVistaCoordinates.push(x);
                cartoVistaCoordinates.push(y);
             }
             else{
                 var previousX = coordArray[idx - 1][0] * 20037508.34 / 180,
                     previousY = Math.log(Math.tan((90 + coordArray[idx - 1][1]) * Math.PI / 360)) / (Math.PI / 180);
                 previousY = previousY * 20037508.34 / 180;
                var deltaX = previousX - x;
                var deltaY = previousY - y;
                cartoVistaCoordinates.push(deltaX);
                cartoVistaCoordinates.push(deltaY);
             }
        });
    };

    return {
        LAYER_ID : "GEOCODER_CP",
        LAYER_TYPE : "POLYGON",
        LOADING_MODE : "ON_DEMAND",
        INDEX : 22,
        DATATABLE_ID : "t_GEOCODER_CP",
        SEARCH_VIEW: {
            QUERY_DATA: function(searchCriteria) {
                return {
                    q: searchCriteria,
                    type: "codes-postaux",
                    geometry: 1,
                };
            },
            CALCUL_FEATURE_ID: function(feature){
                return feature.properties.code;
            },
            CALCUL_FEATURE_TEXT: function(feature){
                return feature.properties.nom;
            },
            CALCUL_GEOMETRY: function(feature){
                if(feature.geometry.type == "Polygon"){
                    var cartoVistaCoordinates = [];
                    var coordArray = feature.geometry.coordinates[0];
                    _createCoordinates(coordArray, cartoVistaCoordinates);
                    return [cartoVistaCoordinates];
                }else if(feature.geometry.type == "MultiPolygon"){
                    return _.map(feature.geometry.coordinates, function(ring){
                        var cartoVistaCoordinates = [];
                        var coordArray = ring[0];
                        _createCoordinates(coordArray, cartoVistaCoordinates);
                       return cartoVistaCoordinates;
                    });
                }

            },
        },
        FIELDS : [
          {ID : "ID", NAME : "Id", DATA_TYPE : "STRING", VALUE : "{{ID}}"},
          {ID : "CD_POSTL", NAME : "Code postal", DATA_TYPE : "STRING", VALUE : "{{TEXT}}"}
        ],
        STYLES : [
            {
                ID : "Code Postal",
                SYMBOLIZERS : [
                    {
                        SYMBOLIZER_TYPE : "PolygonSymbolizer",
                        FILL_STYLE : "SOLID",
                        FILL_COLOR_1: "rgba(6,184,98,0.3)",
                        STROKE_COLOR : "rgba(6,184,98,1)",
                        STROKE_STYLE : "LINE",
                        STROKE_WIDTH : 1
                    }
                ],
                STYLE_LABEL_PROPERTIES : {
                    BOLD : true,
                    COLOR : "rgba(6,184,98,1)",
                    FONT_NAME : "Arimo-Regular",
                    FONT_FILE_SOURCE : "fonts/externals/Arimo-Regular",
                    HALO_COLOR : "rgba(255,255,255,1)",
                    HAS_HALO_COLOR : true,
                    SIZE : 8,
                    VISIBLE : true
                }
            }
        ],
        LAYER_PROPERTIES : {
            NAME : "Code postal",
            FEATURE_ID_DATACOLUMN : "ID",
            FEATURE_NAME_DATACOLUMN : "CD_POSTL",
            DATATIP_DATACOLUMNS : ["CD_POSTL"],
            DATATIP_DATACOLUMNS_DISPLAY_MODE : "NONE",
            DATAVIEW_DATACOLUMNS : ["CD_POSTL"],
            DATAVIEW_DATACOLUMNS_DISPLAY_MODE : "NONE",
            INFOVIEW_DATACOLUMNS : ["CD_POSTL"],
            INFOVIEW_DATACOLUMN_DISPLAY_MODE : "NONE",
            SEARCHABLE_DATACOLUMNS : ["CD_POSTL"],
            IS_VISIBLE_IN_LAYER_CONTROL : false,
            IS_VISIBLE_IN_LEGEND : false,
            SHOW_STYLES_IN_LAYER_CONTROL : false,
            LABEL_DATACOLUMN : "CD_POSTL",
            LABEL_PROPERTIES : {
                ALLOW_LABEL_DUPLICATES : true,
                LEADER_LINES : false,
                POSITION : "MIDDLE-RIGHT",
                PRIORITY : 10
            },
            VISIBLE : true,
        }
    };
});
